export default "__VITE_ASSET__tAvHspKf__"